const writeClipboard = async (string: string): void => {
	const clipboardItem = new ClipboardItem({ 'text/plain': string });
	await navigator.clipboard.write([clipboardItem]);
};

export class FieldCopy {
	private readonly element: HTMLElement;
	private readonly activeClass: string = 'field-copy--active';
	private value: HTMLElement;
	private button: HTMLButtonElement;
	private timer: NodeJS.Timeout;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private clearActivity = (): void => this.element.classList.remove(this.activeClass);

	private setActivity = (): void => {
		clearTimeout(this.timer);
		this.element.classList.add(this.activeClass);
		this.timer = setTimeout(this.clearActivity, 5000);
	};

	private handleButtonClick = (): void => {
		this.setActivity();
		writeClipboard(this.value.innerText);
	};

	public init = (): void => {
		this.value = this.element.querySelector('.field-copy__value');
		this.button = this.element.querySelector('.field-copy__button');

		this.button.addEventListener('click', this.handleButtonClick);
	};
}
